import { TAppDispatch } from 'store/types'
import { getNotifications_API } from 'api'
import campaignSlice from 'store/features/campaign/slice'

const { actions } = campaignSlice

const CAMPAIGN_NOTIFICATION_TYPE = 'campaign'

// The active campaign ships inside the notifications response as the item
// with notificationType === 'campaign' — it carries everything the discount
// button needs (content, discountPercent, endDate). Notifications being
// unavailable is an expected state (the header keeps its default buttons),
// so failures are swallowed.
const initCampaignFromNotifications = () => async (dispatch: TAppDispatch) => {
  try {
    const response = await getNotifications_API()
    const campaignNotification = response.data?.notifications?.find(
      notification =>
        notification.notificationType === CAMPAIGN_NOTIFICATION_TYPE
    )
    if (campaignNotification) {
      dispatch(actions.setCampaign(campaignNotification))
    }
  } catch {
    // Silent — no error popup when notifications are unavailable.
  }
}

export const campaignThunks = {
  ...actions,
  initCampaignFromNotifications
}
